// ----------------------------------------------------------
// © Copyright 2021 European Space Agency, 2021
// This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this [source code/executable] package. No part of the package, including this file, may be copied, modified, propagated, or distributed except according to the terms contained in the file ‘LICENSE.txt’.
// -----------------------------------------------------------
/**
 * EVENTBUS
 * The principle is to exchange information without knowing the emetter, it is a king of broadcast
 * The Store here will be the bus, some code will update the IAppState data and some other code will
 * use the onAppEvent to get notified.
 */
import { createStore } from "@stencil/store";
import dayjs from "dayjs";
export const MAX_ELEMENT_PER_LINE = 5;
export const { state: routingExtraInfo } = createStore({
    extraInfo: null,
});
const { state: allSectionState } = createStore({
    active: true, component: "datalab-section-all", label: "Public", roles: ["user" /* Roles.none */], limit: MAX_ELEMENT_PER_LINE
});
const { state: mySectionState } = createStore({
    active: true, component: "datalab-section-my", label: "Developed by me", roles: ["application-services/developer()" /* Roles.developer */], limit: MAX_ELEMENT_PER_LINE
});
const { state: moderationSectionState } = createStore({
    active: true, component: "datalab-section-moderation", label: "Awaiting Moderation", roles: ["application-services/moderator()" /* Roles.moderator */], limit: MAX_ELEMENT_PER_LINE
});
const { state: officialSectionState } = createStore({
    active: undefined, component: "datalab-section-official", label: "Official ESA", roles: ["user" /* Roles.none */], limit: MAX_ELEMENT_PER_LINE
});
const { state: bookmarkSectionState } = createStore({
    active: true, component: "datalab-section-bookmark", label: "Starred", roles: ["user" /* Roles.none */], limit: MAX_ELEMENT_PER_LINE
});
const { state: runningSectionState } = createStore({
    active: undefined, component: "datalab-section-running", label: "Running", roles: ["user" /* Roles.none */], limit: MAX_ELEMENT_PER_LINE
});
const { state: sharedSectionState } = createStore({
    active: undefined, component: "datalab-section-shared", label: "Shared with me", roles: ["user" /* Roles.none */], limit: MAX_ELEMENT_PER_LINE
});
const { state: sectionState } = createStore({
    running: runningSectionState,
    all: allSectionState,
    official: officialSectionState,
    my: mySectionState,
    moderation: moderationSectionState,
    bookmark: bookmarkSectionState,
    shared: sharedSectionState
});
const { state: appState, on: onAppEvent } = createStore({
    labCreationMode: false,
    newDatalabId: null,
    user: null,
    sections: sectionState,
    datalab: null,
    bookmarked: null,
    unBookmarked: null
});
const { state: datalabsState, on: onDatalabsEvent, reset: datalabsReset } = createStore({
    lastUpdate: {},
    all: [], // List of datalabs and containers that should be shown in various sections of the main page
    running: [],
    bookmarked: []
});
/**
 * hook on the data change to keep the lastUpdate properly set
 */
onDatalabsEvent('set', (key, value) => {
    if (key !== "lastUpdate") { // save the time it was updated only if there is values in it
        datalabsState.lastUpdate[key] = (value === null || value === void 0 ? void 0 : value.length) !== 0 ? +dayjs() : undefined;
    }
});
/**
 * hook on the reset to clean the data associated
 */
onDatalabsEvent('reset', () => {
    datalabsState.lastUpdate = {};
});
// export all the stores and methods needed outside (datalabsReset is used in unit tests)
export { datalabsState, appState, datalabsReset, onAppEvent, onDatalabsEvent };
